export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center pt-16">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-white/80 via-white/60 to-white"></div>
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20collage%20with%20sneakers%20denim%20jacket%20bag%20and%20accessories%20on%20warm%20sand%20colored%20textured%20paper%20background%2C%20editorial%20magazine%20style%2C%20golden%20hour%20lighting%2C%20organic%20composition%20with%20scattered%20elements%2C%20creative%20layout&width=1800&height=1200&seq=hero-bg-v2&orientation=landscape"
          alt="AcBuy Spreadsheet fashion finds and streetwear products"
          title="AcBuy Spreadsheet - Trusted Fashion Finds"
          className="absolute inset-0 w-full h-full object-cover object-center"
          loading="eager"
        />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-0 max-w-7xl mx-auto">
          <div className="w-full lg:w-5/12 text-center lg:text-left">
            <span className="inline-block text-xs font-medium text-foreground-700 tracking-widest uppercase mb-4 bg-white/80 px-4 py-1.5 rounded-full">
              Updated Weekly · 2026 Edition
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-7xl font-heading font-bold text-foreground-950 leading-none mb-6">
              <span className="block">AcBuy</span>
              <span className="block">Spreadsheet</span>
              <span className="block text-accent-500">2026</span>
            </h1>
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-8 max-w-lg mx-auto lg:mx-0">
              Discover trusted sellers, popular finds, buyer guides, and updated spreadsheets for sneakers, fashion, bags, and streetwear.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-white bg-primary-500 hover:bg-primary-600 rounded-full transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                Browse Spreadsheet
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-foreground-800 border-2 border-foreground-300 hover:border-foreground-500 rounded-full transition-colors whitespace-nowrap cursor-pointer text-center bg-white/60"
              >
                Trusted Sellers
              </a>
            </div>
          </div>

          <div className="w-full lg:w-7/12 relative h-[320px] md:h-[420px] lg:h-[500px]">
            <div className="absolute top-0 right-0 w-[75%] h-[70%] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Three%20pairs%20of%20colorful%20fashion%20sneakers%20on%20terracotta%20textured%20surface%2C%20editorial%20product%20photography%2C%20golden%20afternoon%20sunlight%2C%20warm%20vibrant%20composition%2C%20creative%20angled%20arrangement&width=900&height=700&seq=hero-v2-img-1&orientation=landscape"
                alt="AcBuy Spreadsheet sneakers category"
                title="AcBuy Spreadsheet Shoes Category"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="absolute bottom-8 left-4 w-[45%] h-[45%] rounded-2xl overflow-hidden z-10">
              <img
                src="https://readdy.ai/api/search-image?query=Layered%20outfit%20flatlay%20with%20bomber%20jacket%20over%20hoodie%20on%20light%20sage%20green%20linen%2C%20editorial%20fashion%20photography%2C%20bright%20natural%20light%2C%20fresh%20modern%20composition&width=600&height=500&seq=hero-v2-img-2&orientation=landscape"
                alt="AcBuy Spreadsheet jackets and hoodies"
                title="AcBuy Spreadsheet Jackets Category"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="absolute top-8 right-8 w-[30%] h-[30%] rounded-2xl overflow-hidden z-20">
              <img
                src="https://readdy.ai/api/search-image?query=Leather%20crossbody%20bag%20and%20minimalist%20watch%20on%20light%20blush%20pink%20surface%2C%20luxury%20product%20photography%2C%20soft%20studio%20lighting%2C%20elegant%20minimal%20composition&width=400&height=400&seq=hero-v2-img-3&orientation=squarish"
                alt="AcBuy Spreadsheet bags and accessories"
                title="AcBuy Spreadsheet Accessories"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}